/**
 * Resolves when any element is found matching the selector.
 *
 * @param selector Selector to match element with.
 * @param timeLimit Time limit in millseconds before the promise rejects.
 */
export function waitForElement<T>(selector: string, timeLimit: number): Promise<T> {
  return new Promise((resolve, reject) => {
    // Invalid time limit?
    if (timeLimit <= 0) {
      reject('Invalid time limit.');
      return;
    }

    // Element already exists?
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector) as unknown as T);
      return;
    }

    // Rejects the promise when time limit has passed.
    const timeoutId = setTimeout(() => {
      reject(
        `Could not find any elements using selector ${selector} within the specified time limit ${timeLimit} milliseconds.`,
      );
      observer.disconnect();
    }, timeLimit);

    // Start observing.
    const observer = new MutationObserver((mutationsList: any) => {
      if (document.querySelector(selector)) {
        clearTimeout(timeoutId);
        observer.disconnect();
        resolve(document.querySelector(selector) as unknown as T);
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}
